import { formatSsn, P, Stack, useText } from "@sveabank/cc-common";
import Card from "../../../../components/card";
import type {
	BeneficialOwner,
	ForeignBeneficialOwner,
} from "../../../../types/beneficial-ownership";

type Props = {
	bo: BeneficialOwner | ForeignBeneficialOwner;
	id: string;
};

const BeneficialOwnerItem = ({ bo, id }: Props) => {
	const [t, texts] = useText();

	return (
		<Card classNames="bg-background-secondary">
			<Stack direction="row" align="start">
				<Stack>
					<P bold>{`${bo.firstName} ${bo.lastName}`}</P>
					<P>{formatSsn(id)}</P>
				</Stack>
				<P>{t(texts.kyc.beneficialOwnership.share, bo.companyShare.min, bo.companyShare.max)}</P>
			</Stack>
		</Card>
	);
};

export default BeneficialOwnerItem;
